exports.onRouteUpdate = () => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  setTimeout(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'gatsby-route-change' })
  }, 50)
}
